module.exports = __webpack_public_path__ + "static/btgPactualLogo-ed8500996d4c254ed41b8fe16503b818.svg";